import { BlueBtn } from '__components/BlueBtn';
import Mask from '__components/Mask';
import { EmTouchableOpacity } from 'emrn-design/EmTouchable';
import { LinearGradient } from 'emrn-design/LinearGradient';
import { Spacer } from 'emrn-design/Spacer';
import { rpx } from 'emrn-design/rpx';
import { closeContainer } from 'emrn-hybrid/closeContainer';
import React, { Component } from 'react';
import { StyleSheet, View, Text, Image } from 'react-native';

interface Props {
  onPress?: Function;
}

interface State {
  isShow: boolean;
}

export class LeaveRetainPop extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isShow: false,
    };
  }

  show = () => {
    this.setState({ isShow: true });
  };

  hide = () => {
    this.setState({ isShow: false });
  };

  render() {
    const { onPress } = this.props;
    const { isShow } = this.state;
    return (
      <>
        {isShow ? (
          <Mask>
            <View style={styles.content}>
              <LinearGradient
                start={{ x: 0, y: 0.02 }}
                end={{ x: 0, y: 0.31 }}
                colors={['#FFF7C2', '#FFFFFF']}
                style={styles.main}
              >
                <Spacer size={rpx(25)} />
                <Image style={styles.titleImg} source={require('../../images/invite/reallyLeave.png')} />
                <Spacer size={rpx(22)} />
                <View>
                  <Text style={styles.tipText}>
                    你已经获得了<Text style={styles.textBold}>0.68元</Text>，只要完成1个
                  </Text>
                  <Text style={styles.tipText}>惊喜任务就可以提现了哦</Text>
                </View>
                <View style={styles.bottomBtn}>
                  <EmTouchableOpacity
                    activeOpacity={0.9}
                    onPress={() => {
                      onPress && onPress();
                      this.hide();
                    }}
                  >
                    <Image style={styles.nextBtn} source={require('../../images/invite/toComplete.png')} />
                  </EmTouchableOpacity>
                  <EmTouchableOpacity
                    activeOpacity={0.9}
                    onPress={() => {
                      closeContainer();
                    }}
                  >
                    <Image style={styles.nextBtn} source={require('../../images/invite/leave.png')} />
                  </EmTouchableOpacity>
                </View>
              </LinearGradient>
            </View>
          </Mask>
        ) : null}
      </>
    );
  }
}

const styles = StyleSheet.create({
  content: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  main: {
    width: rpx(300),
    height: rpx(220),
    backgroundColor: '#fff',
    borderRadius: rpx(32),
    alignItems: 'center',
  },
  titleImg: {
    width: rpx(156),
    height: rpx(21.5),
    zIndex: 11,
  },
  bottomBtn: {
    marginTop: rpx(30),
    width: rpx(300),
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },
  nextBtn: {
    width: rpx(132),
    height: rpx(40),
    borderRadius: rpx(20),
  },
  rightBtn: {
    width: rpx(120),
    height: rpx(40),
    backgroundColor: '#e0e2fe',
    borderRadius: rpx(20),
  },
  tipText: {
    color: '#333333',
    fontSize: rpx(15),
    lineHeight: rpx(24),
    textAlign: 'center',
  },
  textBold: {
    color: '#FF2233',
    fontSize: rpx(15),
  },
});
